/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { useUserStore } from '@/store/modules/user';
import { toLoginRoute } from '@/utils/routes';
import { useSettingsStore } from '@/store/modules/settings';
import { systemIndex } from '@/api/platform';
import { reactive, toRefs, onMounted } from 'vue';
import { getUserInfo } from '@/api/user';
export default {
  name: 'NavBar',
  props: {
    navBarActiveUrl: {
      type: String,
      default: ''
    },
    navBarList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ['clickNavBar'],
  setup(props, {
    emit
  }) {
    const settingsStore = useSettingsStore();
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const {
      username
    } = storeToRefs(userStore);
    const {
      website
    } = storeToRefs(settingsStore);
    const {
      logout
    } = userStore;
    // const { getUserInfo } = useUserStore()
    const state = reactive({
      screenWidth: window.innerWidth,
      username,
      actNum: 1,
      userInfo: {},
      website,
      logo: require('@/assets/logo/defineLogo.png'),
      authorizeData: '',
      isService: false
    });
    watch(() => state.screenWidth, val => {
      state.screenWidth = val;
    }, {
      immediate: true,
      deep: true
    });
    onBeforeMount(async () => {
      const {
        data
      } = await systemIndex();
      state.authorizeData = data.authorizeData;
      window.onresize = () => {
        return (() => {
          state.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        })();
      };
    });
    const clickNavBar = (index, url) => {
      emit('clickNavBar', index, url);
    };
    const bzZx = () => {
      // window.open('https://www.yuque.com/yiqibankeji')
      window.open('https://www.yuque.com/yunbeikeji');
    };
    const tjjy = () => {
      // window.open('https://www.yuque.com/yiqibankeji')
      window.open('https://support.qq.com/product/545013');
    };
    const logoutM = async () => {
      await logout();
      await router.push(toLoginRoute(route.fullPath));
    };
    const goDeployManage = () => {
      router.push('/deploy/manage');
    };
    const fetchData = async () => {
      const {
        data
      } = await getUserInfo();
      state.userInfo = data;
      // console.log(data, '000000000');
    };
    const lxkf = () => {
      state.isService = true;
    };
    const hhh = () => {
      console.log('00000');
    };
    onMounted(() => {
      fetchData();
    });
    return {
      ...toRefs(state),
      clickNavBar,
      logoutM,
      bzZx,
      tjjy,
      fetchData,
      lxkf,
      hhh,
      goDeployManage
    };
  }
};